import { sendDataLayerEvent } from '../../utils/dataLayerInteractions';
import EventNamesType from '../eventNamesType';

type BookingData = {
  number_of_children: number;
  date: string;
  fitting_location: string;
  postcode: string;
};

export const sendBookAFittingEvent = (bookingData: BookingData) => {
  sendDataLayerEvent(EventNamesType.book_a_fitting, { custom_data: bookingData });
};
